export default __webpack_public_path__ + "static/media/035-volcano.fd178f50.svg";